module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/31EixMqZUQkWu2aCmWiYC0-954350d0325ca98d1ff5e8e829f6b586.jpg";